module.exports = __webpack_public_path__ + "static/media/WM5@1.5x.ce4a29f1.png";